import React from 'react';
import { Chip, Button, Popover, Box } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

const TopBarFilters = (props) => {
  const {
    id,
    open,
    anchorEl,
    handleDelete,
    handleClose,
    filters,
    filterCount,
    onAutoSuggestFilterChange,
    onResetExperience,
    onResetScore,
    onResetVisaSponsorship,
    resetFilters,
    visaFilter,
  } = props;

  const chipStyles = {
    border: '1px solid #0000001f',
    margin: '5px',
    background: '#ffffff',
  };

  const getVisaSponsorshipFilter = () => {
    const { required, notRequired } = visaFilter;
    var array = [];
    if (required) {
      const label = `Visa Sponsorship - required`;
      array.push(
        <Chip
          label={label}
          onDelete={onResetVisaSponsorship({ required: false })}
          variant="outlined"
          style={chipStyles}
        />
      );
    }
    if (notRequired) {
      const label = `Visa Sponsorship - Not Required`;
      array.push(
        <Chip
          label={label}
          onDelete={onResetVisaSponsorship({ notRequired: false })}
          variant="outlined"
          style={chipStyles}
        />
      );
    }
    return array;
  };

  const getLocations = () => {
    let locationChips = null;
    const { locations } = filters;
    if (locations.length > 0) {
      locationChips = locations.map((location) => (
        <Chip
          label={location}
          onDelete={onAutoSuggestFilterChange('locations', location)}
          variant="outlined"
          style={chipStyles}
        />
      ));
    }
    return locationChips;
  };

  const getCompanies = () => {
    const { companies } = filters;
    if (companies.length > 0) {
      return companies.map((company) => (
        <Chip
          label={company}
          onDelete={onAutoSuggestFilterChange('companies', company)}
          variant="outlined"
          style={chipStyles}
        />
      ));
    }
  };

  const getMatchScoreFilter = () => {
    const { overallScoreStart, overallScoreEnd } = filters;
    if (overallScoreStart > 0 || overallScoreEnd < 100) {
      const label = `Match score ${overallScoreStart} - ${overallScoreEnd} %`;
      return (
        <Chip
          label={label}
          onDelete={onResetScore}
          variant="outlined"
          style={chipStyles}
        />
      );
    }
    return null;
  };

  const getExperienceFilter = () => {
    const { experienceStart, experienceEnd } = filters;
    if (experienceStart > 0 || experienceEnd < 50) {
      const label = `Experience ${experienceStart} - ${experienceEnd} years`;
      return (
        <Chip
          label={label}
          onDelete={onResetExperience}
          variant="outlined"
          style={chipStyles}
        />
      );
    }
    return null;
  };

  return (
    <>
      <Chip
        label={`+${filterCount} filters`}
        onDelete={handleDelete}
        variant="outlined"
        deleteIcon={<ExpandMore aria-describedby={id} />}
        style={chipStyles}
      />
      <Button
        style={{
          color: 'rgba(0, 0, 0, 0.6)',
          fontFamily: 'roboto',
          textTransform: 'unset',
        }}
        onClick={resetFilters}
      >
        Clear All
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        style={{ marginTop: '7px' }}
      >
        <Box
          style={{
            padding: '5px',
            maxWidth: '347px',
          }}
        >
          {getLocations()}
          {getCompanies()}
          {getMatchScoreFilter()}
          {getExperienceFilter()}
          {getVisaSponsorshipFilter()}
        </Box>
      </Popover>
    </>
  );
};

export default TopBarFilters;
